<template>
  <div class="customer-service">
      <div class="title">客户服务绩效</div>
      <div>
        <OrderDefect :orderDefects="serves.orderDefects"/>
        <NotSatisfied :returnDissatisfactionData="serves.returnDissatisfactionData"/>
        <InvoiceDefect v-if="serves.invoiceDefect" :invoiceDefect="serves.invoiceDefect"/>
      </div>
  </div>
</template>

<script>
import OrderDefect from "@/views/components/early-warning/order-defect";
import NotSatisfied from "@/views/components/early-warning/not-satisfied";
import InvoiceDefect from "@/views/components/early-warning/Invoice-defect";

export default {
  components: {OrderDefect, NotSatisfied, InvoiceDefect},
  props: {
    serves: {
      default: () => ({})
    }
  }
}
</script>

<style scoped lang="scss">
.customer-service {
  padding-bottom: 31px;
  .title {
    line-height: 50px;
    padding-left: 20px;
    border-bottom: 1px solid #eee;
    font-weight: 600;
    font-size: 14px;
    color: #333;
  }
}
</style>